// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"147":"b8e1ac30","198":"899c5eb5","835":"b8e1ac30","922":"b8e1ac30","935":"b8e1ac30","981":"5ec34d30"}[chunkId] + ".chunk.css";
};